import {Injectable} from '@angular/core';
import {LockdownGroupsResults, LockdownInfoQeuryResult, LockForm} from '../models/lockdown/lockdown';
import {GraphQLClientService} from './graphql-client.service';

@Injectable({
  providedIn: 'root'
})

export class LockdownService {

  constructor(private graphQLClient: GraphQLClientService) {
  }

  async getGroupsSummary(page: number, count: number, searchTerm: string = ''): Promise<LockdownGroupsResults> {
    const query = `query{
  lockdowns(nameContains: "${searchTerm}")
  {results{id comments groupRemainingTimeSeconds totalRemainingTime totalOpen totalLockdown description name unlockCardsCount lockCardsCount
    doorsCount outputsCount immunedEmployeesCount status } totalCount
  }
}`;
    return (await this.graphQLClient.requestAsync<LockdownGroupsResults>(query))?.data;
  }

  async getGroupDetailsById(groupId): Promise<LockdownInfoQeuryResult> {

    const query = `query{
  lockdown(id:${groupId})
  {
    id status reason description name lockdownDefaultTimeSeconds outputs{panelId outputSlot outputRemainingTimeSeconds name description lockownOutputTypeId lockownOutputTypeName status} immunedEmployees {id name department} cards{id description statusId status name action} links {name trigger}
  }
}`;
    return (await this.graphQLClient.requestAsync<LockdownInfoQeuryResult>(query))?.data;
  }

  async sendLockdownOutputsCommand(lockForm: LockForm): Promise<any> {
    const query = `mutation{
      lockdownOutputs(lockdownCommand: ${JSON.stringify(lockForm).replace(/"(\w{2,})":/gm,'$1:')})
    }`;
    return (await this.graphQLClient.requestAsync<any>(query))?.data;
  }

  async getLockdownConfigurations(): Promise<any> {
    const query = `query{
      configurations{
       lockdownConfigurations {lockdownCommands{id description} }
      }
    }`;
    return (await this.graphQLClient.requestAsync<any>(query))?.data.configurations.lockdownConfigurations;
  }
}

